<div [ngClass]="{ centerOfAll: center }">
  <div>
    <div class="loading text">{{ loadingText }}</div>
    <div></div>
    <div></div>
  </div>
</div>
